// extracted by mini-css-extract-plugin
export default {"backGroundPicture":"products_backGroundPicture__WThJV","sidebar1":"products_sidebar1__6S6Ol","h3":"products_h3__zNwNV"};